import { css, keyframes } from "@compiled/react";

import { Picture } from "@/components/wpl/image/src";
/* white logos */
export const ProductMarkJira = () => {
    return (
        <Picture
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-logo.svg",
                alt: "Jira"
            }}
        />
    );
};

export const ProductMarkConfluence = () => {
    return (
        <Picture
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-logo.svg",
                alt: "Confluence"
            }}
        />
    );
};
export const ProductMarkJSM = () => {
    return (
        <Picture
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-logo.svg",
                alt: "Jira Service Management"
            }}
        />
    );
};

export const ProductMarkLoom = () => {
    return (
        <Picture
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/loom-logo.svg",
                alt: "Loom"
            }}
        />
    );
};

export const ProductMarkJPD = () => {
    return (
        <Picture
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-logo.svg",
                alt: "Jira Product Discovery"
            }}
        />
    );
};

export const ProductMarkAtlassianIntellignce = () => (
    <Picture
        image={{
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/atlassian-intelligence.svg",
            alt: "Atlassian Intelligence"
        }}
    />
);

// "Accent" Images for Scroll-pinned section
export const SquiggleLineAccent1 = () => {
    return (
        <Picture
            className="squiggle-line-accent-1"
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/squiggle-1.svg",
                alt: ""
            }}
            css={[
                accentImgStyles,
                css({
                    insetInlineStart: "21px",
                    insetBlockStart: "-19px"
                })
            ]}
        />
    );
};

export const SquiggleLineAccent2 = () => {
    return (
        <Picture
            className="squiggle-line-accent-2"
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/squiggle-2.svg",
                alt: ""
            }}
            css={[
                accentImgStyles,
                css({
                    insetInlineStart: "36px"
                })
            ]}
        />
    );
};

export const ArrowGroupAccent = () => {
    return (
        <Picture
            className="arrow-group-accent"
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/arrow-grp.svg",
                alt: ""
            }}
            css={[
                accentImgStyles,
                css({
                    insetInlineStart: "16px",
                    insetBlockStart: "-7px"
                })
            ]}
        />
    );
};

export const StarGroupAccent = () => {
    return (
        <Picture
            className="star-group-accent"
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/star-grp.svg",
                alt: ""
            }}
            css={[
                accentImgStyles,
                css({
                    insetBlockStart: "-30px"
                })
            ]}
        />
    );
};

export const LightningAccent1 = () => {
    return (
        <Picture
            className="lightning-accent-1"
            image={{
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/lightning.svg",
                alt: ""
            }}
            css={[
                accentImgStyles,
                css({
                    insetInlineStart: "-16px",
                    insetBlockStart: "-10px"
                })
            ]}
        />
    );
};
const strokeRight = keyframes({
    from: {
        clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)"
    },
    to: {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)"
    }
});
const accentImgStyles = css({
    animation: `${strokeRight} ease-in-out .5s 1`,
    position: "relative"
});
